import React from 'react';
import {  Navigate, NavigateFunction, NavigateOptions, Route } from 'react-router-dom';
import { RouteInterface } from '../interfaces';
import { AppRoutes } from 'src/pages/app/_router/app.routes';

let navigateFunction: any;

const setNavigateFunction = (navigate: NavigateFunction) => {
  navigateFunction = navigate;
}

export const navigate = (route: string | number, options?: NavigateOptions) => {
  if (navigateFunction) {
    navigateFunction(route, options);
  } else {
    console.error('navigateFunction is not set');
  }
}

function generateRoutes(routes: Array<RouteInterface>): React.ReactNode {
  // const allowedRoutes = routes.filter((r: RouteInterface) => {
  //   if (r.functions && r.functions.length > 0) {
  //     const accessGranted = GuardFunction(r.functions);
  //     if (!accessGranted) return false;
  //   }
  //   return true;
  // });
  return (
    <>
      {routes.map((route: RouteInterface, index: number) =>
        (
          <Route key={index} path={route.path} element={
            <route.element>
            </route.element>
          }>
            {!!route.children && generateRoutes(route.children)}
          </Route>
        )
      )}
      
      <Route path="*" element={<Navigate to={AppRoutes.ROOT} replace />} />
    </>
  )
}


export const NavigationService = {
  generateRoutes,
  setNavigateFunction,
  navigate
};
